import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getPrioridades = async() => {
    const result = await PrivateInterceptor(`Global/Prioridades`, 'GET')
    return result;
}